/* eslint-disable no-param-reassign */
import m from "mithril";
import moment from "moment";
import header from "../../components/header";
import toolbar from "../../components/toolbar"
import sidebar from "../../components/sidebar"
import table_data from "../../components/table_data"
import graph from "./components/graph";
import multiSelect from "../../components/bootstrap-select";
import companyBannner from "../../components/companyBannner";
import { runQuery, headers } from "../../utils/fetchData";
import timePicker from "../../components/timePicker";
import htmlEditor from "../../components/htmlEditor";
import config from "../../config";
import stats from "./components/stats";
import map from "./components/google-maps";
import tmpMap from "./components/tmpMap";
import tutorials from "./components/tutorials";
import commonQuestions from "./components/commonQuestions";
import dataMap from "../../utils/data";

import { t } from '../../translation-files/translator'

import addTutorials from "./modals/add"
import footer from "../../components/footer";


function getNumberWithOrdinal(i) {
  const j = i % 10;

  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return "rd";
  }
  return `${i}th`;
}

export default {
  async oninit({ state, attrs }) {
    Object.assign(state, {
      selectedTeams: [],
      selectedUsers: [],
      selectedProjects: [],
      teams: [],
      users: [],
      projects: [],
      projectsT: true,
      teamsT: false,
      usersT: false,
      fetching: false,
      selectedTime: {
        end: moment(new Date()),
        start: moment(new Date())
          .subtract(6, "day")
          .startOf("day")
      },
      data: [],
      labels: [],
      stats: {},
      gpsData: []
    });

    state.fetchResults = async clientId => {
      const { start, end } = state.selectedTime;

      state.fetching = true;
      m.redraw();

      try {
        const results = await m.request({
          method: "POST",
          headers: headers(),
          url: `${config[window.env].apiUrl}/submision/breakDayDown/${new Date(
            start
          ).toISOString()}/${new Date(end).toISOString()}`,
          data: Object.assign(
            {
              client: clientId
            },
            state.teamsT === true
              ? { teamId: { $in: state.selectedTeams } }
              : {},
            state.projectsT === true
              ? { projectId: { $in: state.selectedProjects } }
              : {},
            state.usersT === true
              ? { userId: { $in: state.selectedUsers } }
              : {}
          )
        });

        Object.assign(state, {
          fetching: false,
          data: [],
          labels: []
        });
        m.redraw();

        const labels = Object.values(results)
          .reverse()
          .map(
            ({ start }) =>
              `${getNumberWithOrdinal(moment(start).format("DD"))}-${moment(
                start
              ).format("MM")}`
          );

        const data = Object.values(results)
          .reverse()
          .map(({ count }) => count);

        const gpsData = Object.values(results)
          .reverse()
          .map(({ data }) => data);

        Object.assign(state, {
          data,
          labels,
          gpsData
        });

        m.redraw();
      } catch (err) {
        Object.assign(state, {
          fetching: false
        });
        m.redraw();
      }
    };

    state.resetSelections = () => {
      Object.assign(state, {
        selectedTeams: [],
        selectedUsers: [],
        selectedProjects: [],
        teams: [],
        users: [],
        projects: [],
        projectsT: true,
        teamsT: false,
        usersT: false,
        selectedTime: {
          end: moment(new Date()),
          start: moment(new Date())
            .subtract(6, "day")
            .startOf("day")
        },
        fetching: false,
        data: [],
        labels: []
      });

      m.redraw();
    };

    const {
      users,
      id: clientId,
      stats,
      teams,
      projects
    } = await dataMap.getClientData();

    Object.assign(state, {
      projects,
      teams,
      users,
      stats,
      clientId,
      selectedTeams: [...teams.map(p => p.id)],
      selectedUsers: [...users.map(p => p.id)],
      selectedProjects: [...projects.map(p => p.id)]
    });

    state.fetchResults(clientId);
    m.redraw();
  },
  // disable due to failures on some browsers
  oncreate() {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const accType = urlParams.get('u');
    //   if (accType === 'new')
    //     introJs().start();
  },
  view({ state, attrs }) {
    console.log({ t: t() })
    return [
      // <!--begin::Header-->
      m(addTutorials),
      m(header, {
        logos: {
                  dark: "assets/media/logos/rubis-logo-white.svg",
          light: "assets/media/logos/rubis-logo-white.png"
        },
        links: [{
          label: t().home_acc_info.navbar.reports,
          route: "/reports",
        }, {
          label: t().home_acc_info.navbar.user_management,
          route: "/userManagement"
        }, {
          label: t().home_acc_info.navbar.support,
          route: "/support",
          routesToActivate: ["/support", "/tutorials"]
        }, {
          label: t().home_acc_info.navbar.notifications,
          route: "/notifications"
        }, {
          label: t().home_acc_info.navbar.trends,
          route: "/trends-disabled"
        }]
      }),
      // <!--end::Header-->

      // <!--begin::Wrapper-->
      m("div", { "class": "app-wrapper flex-column flex-row-fluid", "id": "kt_app_wrapper" }, [
        // <!--begin::Main-->
        m("div", { "class": "app-main flex-column flex-row-fluid", "id": "kt_app_main" }, [
          // <!--begin::Content wrapper-->
          m("div", { "class": "d-flex flex-column flex-column-fluid" }, [
            // <!--begin::Toolbar-->
            m(toolbar, {
              header: {
                label: "XYZ Transporters",
                subLabel: [t().common.account_type, t().common.post_paid]
              },
              toolBarItems: [{
                label: t().home_acc_info.subheader_labels.dashboard,
                route: "/dashboard",
                routesToActivate: ["/dashboard"]
              }, {
                label: t().home_acc_info.subheader_labels.home,
                route: "/",
                routesToActivate: ["/", "/stationFinder", "/journeyPlan"]
              }, {
                label: t().home_acc_info.subheader_labels.cards,
                route: "/cardList",
                routesToActivate: ["/cardList", "/departments", "/drivers"]
              }, {
                label: t().home_acc_info.subheader_labels.transactions,
                route: "/transactions",
                routesToActivate: ["/transactions"]
              }, {
                label: t().home_acc_info.subheader_labels.funds,
                route: "/funds",
                routesToActivate: ["/funds", "/cardToCard"]
              }]
            }),
            // <!--end::Toolbar-->

            // <!--begin::Content-->
            m("div", { "class": "app-container container-xxl", "id": "kt_app_content_container" }, [
              // <!--begin::Inbox App - Messages -->
              m("div", { "class": "d-flex flex-column flex-lg-row" }, [
                // <!--begin::Sidebar-->
                m(sidebar, {
                  sideBarItems: [{
                    label: t().notifications.sidebar_labels.alerts,
                    icon: "bi bi-bell",
                    route: "/notifications"
                  },
                  {
                    label: t().notifications.sidebar_labels.triggers,
                    icon: "bi bi-clock-history",
                    route: "/notifications/triggers"
                  }]
                }),
                // <!--end::Sidebar-->
                // <!--begin::Content-->
                m("div", {
                  "class": "app-content", "id": "kt_app_content", style: {
                    "flex-grow": 1,
                    "flex-basis": "auto",
                  }
                },
                  m("div", { "class": "app-container container-xxl", "id": "kt_app_content_container" },
                    [
                      m(table_data, {
                        overideHeader: true,
                        title: t().notifications.notification_list.title,
                        customHeader: [
                          [{
                            label: "Balance Notifications",
                            amount: 4
                          }, {
                            label: "Tickets Raised",
                            amount: 5
                          }, {
                            label: "Fraud Alert",
                            amount: 1
                          }].map(({ label, amount }) => {
                            return m("div", {
                              "class": "col pe-2 ps-2 pb-2 pt-2",
                            },
                              m("div", {
                                "class": "card card-flush",
                                style: {
                                  margin: "20px", // add margin around the div
                                  boxShadow: "0 0 40px rgba(0,0,0,0.2)" // add shadow
                                }
                              },
                                [
                                  m("div", { "class": "card-header pt-5 justify-content-center align-items-center", style: { "margin-bottom": "20px" } },
                                    m("div", { "class": "card-title d-flex flex-column justify-content-center align-items-center" },
                                      [
                                        m("div", { "class": "d-flex align-items-center", style: { 'padding-bottom': "20px" } },
                                          [
                                            m("span", {
                                              "class": "fw-bold text-gray-900 me-2 lh-1 ls-n2",
                                              style: { 'font-size': "1.9rem" }
                                            }, label),
                                          ]
                                        ),
                                        m("span", { "class": "text-gray-500 pt-1 fw-semibold fs-6" },
                                          m.trust(`
                                            <svg width="65" height="62" viewBox="0 0 65 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <ellipse cx="32.2286" cy="31" rx="29.2286" ry="28" fill="white"/>
                                              <path d="M32.2286 60.5C49.1381 60.5 62.9571 47.3525 62.9571 31C62.9571 14.6475 49.1381 1.5 32.2286 1.5C15.319 1.5 1.5 14.6475 1.5 31C1.5 47.3525 15.319 60.5 32.2286 60.5Z" stroke="black" stroke-opacity="0.25" stroke-width="3"/>
                                              <text x="32.2286" y="31" dy="8" text-anchor="middle" font-size="24" font-weight="bold" fill="#333">
                                                <tspan class="fs-2hx fw-bold text-gray-900 me-2 lh-1 ls-n2">${amount}</tspan>
                                              </text>
                                            </svg>
                                          `)
                                        )

                                      ]
                                    )
                                  )
                                ]
                              )
                            )
                          }),
                        ],
                        dataConfigs: {
                          sourceEndpoint: "/notifications",
                          dataMapping: [{
                            label: t().notifications.notification_list.header.notification,
                            data_key: "notification"
                          }, {
                            label: t().notifications.notification_list.header.description,
                            data_key: "description"
                          }],
                          dataRows: Array.from({ length: 25 }, () => ({
                            notification: ["System Alert: New Journey Plan Created", "Warning: Low Balance Detected", "Info: New Tutorial Available", "Error: Payment Failed", "Reminder: Subscription Expiring"][Math.floor(Math.random() * 5)],
                            description: ["A new journey plan has been created for your review.", "Your account balance is running low. Please recharge to avoid interruption in service.", "A new tutorial on advanced searching has been added to the system.", "Payment for your subscription has failed. Please try again.", "Your subscription is expiring soon. Please renew to avoid service interruption."][Math.floor(Math.random() * 5)],
                          }))
                        }
                      })
                    ]
                  )
                )
                // <!--end::Content-->
              ])
              // <!--end::Inbox App - Messages -->
            ])
            // <!--end::Content-->
          ]),
          m(footer)
        ])
      ])

    ];
  }
};
